import i18n from "../../i18n";
import axios from "axios";

const actions = {
  getAllManagedInstructions(context) {
    context.commit("SET_ALL_MANAGEDINSTRUCTIONS");
    return axios
      .get("managedInstruction?analytics=1")
      .then(function (r) {
        context.commit("SET_ALL_MANAGEDINSTRUCTIONS", r.data.data);
        return r.data.data;
      })
      .catch(function (e) {
        context.commit("SET_ALL_MANAGEDINSTRUCTIONS", e);
        context.dispatch("triggerError", e);
      });
  },

  getManagedPresignVideoUpload(context, value) {
    return axios
      .post("managedInstruction/upload?sda", {
        fileName: value,
      })
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
  async createManagedInstruction(context, value) {
    // `value` is the JSON payload with base64 content
    return axios
      .post("/managedInstruction", value)
      .then((r) => {
        return r.data;
      })
      .catch((e) => {
        context.dispatch("triggerError", e);
        throw e;
      });
  },

  async getManagedInstructionById(_, id) {
    return await axios.get(`/managedInstruction/${id}`);
  },

  async updateManagedInstructionPartly(_, { id, payload }) {
    const { data } = await axios.patch(`/managedInstruction/${id}`, payload);
    return data;
  },
};

export default actions;
